// @ts-nocheck

import palette from '../palette';

import { withOpacity } from './helpers';

export const Modal = {
  backgroundColor: {
    betshare: palette.neutralgrey550,
    cgu: palette.bluegrey850,
    default: palette.black,
    fallback: palette.black,
    grids: palette.neutralgrey850,
    widgetPlayer: palette.bluegrey900,
    scanner: withOpacity(palette.black, 'ee'),
    brDesktopWidget: palette.white,
  },
  textColor: {
    default: palette.white,
  },
};
